
import { TransactionMasterData } from "types/models/transactionMaster/TransactionMasterApp";
import { AppActions } from "../../types";
import {  GET_TRANSATION,RESET_TRANSATION_DATA,SET_TRANSATION_DATA } from "types/actions/transactionMaster.action";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentTransaction: TransactionMasterData | null;
  transaction: TransactionMasterData[];
  transactionCount: number;
 
} = {
  currentTransaction: null,
  transaction: [],
  transactionCount: 0,
  
};

const TransactionMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    // Plan-related actions
    case GET_TRANSATION:
      return {
        ...state,
        transaction: action.payload.data,
        total: action.payload.total,
      };
    case SET_TRANSATION_DATA:
      return {
        ...state,
        currentTransaction: action.payload,
      };
      case RESET_TRANSATION_DATA:
        return { ...state, currentContact: null };
    default:
      return state; 
  }
};

export default TransactionMaster;
